module.exports = __webpack_public_path__ + "static/media/empresa-original-ad-flipped.ce5d4d40.png";